import { Routing as MyPlannRouting } from "web_myplann/Infrastructure/Routing/Routing";

export const AppRouting = {
	Login: {
		path: () => "/",
	},
	Dashboard: {
		path: () => "/dashboard",
	},
	MyPlann: MyPlannRouting,
} as const;

export type RouteObject<T extends any[] = any[]> = {
	route?: string;
	path: (...args: T) => string;
};

export function getRoute<T extends RouteObject>(routeObj: T): string {
	return routeObj.route ?? routeObj.path();
}
